export class CustomApiError extends Error {
  response: Response & {
    data?: {
      error: {
        message: string
        status?: number
      }
      errors?: {
        [key: string]: string[]
      }
    }
    statusText: string
  }

  constructor(response: CustomApiError["response"]) {
    const message =
      response?.data?.error?.message ||
      response.statusText ||
      "Custom API Error"
    super(message)
    this.name = "CustomApiError"
    this.response = response

    // Maintains proper stack trace (only available in V8-based engines)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomApiError)
    }
  }
}
